import { useMutation } from '@tanstack/react-query';

import createSignSS4Request from './useCreateSignSS4Request.request';
import { CreateSignSS4RequestPayload } from './useCreateSignSS4Request.interface';

export default function useCreateSignSS4Request() {
    return useMutation({
        mutationFn: (payload: CreateSignSS4RequestPayload) => createSignSS4Request(payload),
    });
}
